/**
 * Workload Summary Component
 * Displays user's workload grouped by various criteria
 */

import React from 'react';
import './WorkloadSummary.css';

interface WorkloadItem {
  id: string;
  title: string;
  type?: string;
  priority?: number;
}

interface WorkloadGroup {
  board_id?: string;
  board_title?: string;
  bucket_id?: string;
  bucket_title?: string;
  priority?: string;
  count: number;
  items: WorkloadItem[];
}

interface WorkloadData {
  total: number;
  groups: WorkloadGroup[];
}

interface WorkloadSummaryProps {
  data: WorkloadData;
}

export const WorkloadSummary: React.FC<WorkloadSummaryProps> = ({ data }) => {
  return (
    <div className="workload-summary">
      <div className="workload-header">
        <h4>Moj Workload</h4>
        <span className="total-badge">{data.total} items</span>
      </div>

      <div className="workload-groups">
        {data.groups.map((group, index) => (
          <div key={index} className="workload-group">
            <div className="group-header">
              <span className="group-name">
                {group.board_title ||
                  group.bucket_title ||
                  group.priority ||
                  'Unknown'}
              </span>
              <span className="group-count">{group.count}</span>
            </div>

            <div className="items-preview">
              {group.items.slice(0, 3).map((item) => (
                <div key={item.id} className="item-preview">
                  <span className="item-type-icon">
                    {item.type === 'ticket' ? '🎫' : '👤'}
                  </span>
                  <span className="item-title">{item.title}</span>
                  {item.priority !== undefined && (
                    <span className="item-priority">P{item.priority}</span>
                  )}
                </div>
              ))}

              {group.items.length > 3 && (
                <div className="more-items">
                  +{group.items.length - 3} više...
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
